export default __webpack_public_path__ + "static/media/phone.be9fe2da.svg";